export interface ExtraUserPricing {
  individualPrice: number;
  packages: Array<{ quantity: number; price: number }>;
}

/**
 * Calcula o custo de usuários extras contratados: usa o preço unitário do maior pacote aplicável
 * (o maior `quantity` que seja <= à quantidade escolhida), ou o preço individual quando nenhum
 * pacote se aplica.
 */
export const calculateExtraUsersCost = (
  extraUsers: number,
  pricing: ExtraUserPricing | undefined,
): number => {
  if (!pricing || extraUsers <= 0) return 0;

  const individual = pricing.individualPrice ?? 0;
  const packages = [...(pricing.packages || [])].sort((a, b) => b.quantity - a.quantity); // Ordenar do maior para o menor

  // Encontrar o maior pacote que seja menor ou igual à quantidade escolhida
  let selectedPackage = null;
  for (const pack of packages) {
    if (extraUsers >= pack.quantity) {
      selectedPackage = pack;
      break; // Usar o maior pacote aplicável
    }
  }

  // Se encontrou um pacote, usar o preço unitário do pacote multiplicado pela quantidade escolhida
  // Se não encontrou, usar preço individual × quantidade
  if (selectedPackage) {
    const pricePerUser = selectedPackage.price / selectedPackage.quantity; // Preço unitário do pacote
    return extraUsers * pricePerUser; // Multiplicar pela quantidade escolhida
  }
  return extraUsers * individual; // Se não há pacote aplicável, usar preço individual
};
